/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import classnames from 'classnames';
import styles from './IonSpinner.module.scss';

export interface IonSpinnerTypes {
  width?: string;
  height?: string;
}

/**
 * @IonSpinner
 *
 * Pulsing spinner component per the DLS
 *
 * ```typescript
 *
 *   <IonSpinner />
 *   <IonSpinner width='60px' height='60px' />
 *
 * ```
 */
export const IonSpinner = ({width = '45px', height = '45px'}: IonSpinnerTypes) => {
  return (
    <div className={styles.spinner} style={{width, height}}>
      <div className={classnames(styles.circle, styles.circle1)} />
      <div className={classnames(styles.circle, styles.circle2)} />
      <div className={classnames(styles.circle, styles.circle3)} />
    </div>
  );
};

export default IonSpinner;
